import { Navigate, Outlet } from 'react-router-dom';

// project-imports
import useAuth from 'hooks/useAuth';

// ==============================|| ACCOUNT GUARD ||============================== //
//
// Wraps the developer pages. Without a developer account there is nothing to show, so the person is taken
// to the sign-up wizard. The outlet is keyed by the account epoch: after a switch every page below
// remounts and loads the new account's data instead of showing the previous one's.

const AccountGuard = () => {
  const { activeAccount, accountEpoch } = useAuth();

  if (!activeAccount) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet key={accountEpoch} />;
};

export default AccountGuard;
